import { render, staticRenderFns } from "./InternalRelatedLetters.vue?vue&type=template&id=406b8dee"
import script from "./InternalRelatedLetters.vue?vue&type=script&lang=js"
export * from "./InternalRelatedLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports